module.exports = __webpack_public_path__ + "static/media/IMG_20201031_121833_003_tn.51a0fafc.jpg";